<svelte:head>
  <script type="module" src="https://cdn.jsdelivr.net/npm/@ionic/core@5.4.0/dist/ionic/ionic.esm.js"></script>
  <script nomodule src="https://cdn.jsdelivr.net/npm/@ionic/core@5.4.0/dist/ionic/ionic.js"></script>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@ionic/core@5.4.0/css/ionic.bundle.css" />
</svelte:head>

<script>
	import { onMount } from 'svelte';
	import { Router, Link, Route, navigate } from "svelte-routing";
	import { get } from 'svelte/store';
	import { accessToken } from './stores/cachedStores';
	import userStore from './stores/userStore';
	import LoginScreen from './routes/LoginScreen.svelte';
	import CasinosScreen from './routes/CasinosScreen.svelte';
	import LobbyScreen from './routes/LobbyScreen.svelte';
	import TableScreen from './routes/TableScreen.svelte';
	import jwt_decode from "jwt-decode"
    import friendsStore from './stores/friendsStore';

	export let url = "";
	let userDataLoaded = false;

	onMount(async () => {
		await accessToken.readFromCache();        //read access token from local cache

		if (get(accessToken))
		{
			var decoded = jwt_decode(get(accessToken));
			try {
				await userStore.getData(decoded.sub);  //try to retrieve user data
				await friendsStore.getFriends(decoded.sub);  //try to retrieve user friends
				userDataLoaded = true;
			} catch (error) {
				console.log("Error: " + error);
				accessToken.delete(); //delete local access token because it's proven to be faulty
			}
		}
	});
	
</script>

<ion-app>
    <Router url="{url}">

	{#if !$accessToken}
	<Route component="{LoginScreen}" />
	{:else}
		{#if userDataLoaded}
			<Route component="{CasinosScreen}" />
			<Route path=":casinoId/lobby" component="{LobbyScreen}" />
			<Route path=":casinoId/:tableId" component="{TableScreen}" />
		{:else}
			loading...
		{/if}
	{/if}

	</Router>
</ion-app>

<style>
	 :root {
    --ion-safe-area-top: 0px;
    --ion-safe-area-bottom: 22px;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100vh;
  }
</style>